@if (order(); as o) {
<!-- Order Meta -->
<div class="detail-section">
  <table class="detail-table">
    <tbody>
      <tr>
        <td>
          <strong>Order Number</strong>
          <p>{{ o.number }}</p>
        </td>
        <td>
          <strong>Date</strong>
          <p>{{ o.date ? (o.date | date: 'mediumDate') : '-' }}</p>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="detail-section">
  <table class="detail-table">
    <tbody>
      <tr>
        <td>
          <strong>Location</strong>
          <p>{{ fullDetail()?.locationName || o.locationName || '-' }}</p>
          @if (fullDetail(); as d) {
          @if (d.locationStreet) {
          <p class="detail-subtext">{{ d.locationStreet }}</p>
          }
          @if (d.locationCity) {
          <p class="detail-subtext">{{ d.locationCity }}, {{ d.locationState }} {{ d.locationZip }}</p>
          }
          }
        </td>
        <td>
          <strong>Transportation Method</strong>
          <p>{{ fullDetail()?.shipVia || o.shipVia || '-' }}</p>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Transport -->
<div class="detail-section">
  <table class="detail-table">
    <tbody>
      <tr>
        <td>
          <strong>BOL</strong>
          <p>{{ o.referenceNumber || '-' }}</p>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Special Instructions -->
@if (fullDetail()?.specialInstructions) {
<div class="detail-section">
  <table class="detail-table">
    <tbody>
      <tr>
        <td>
          <strong>Special Instructions</strong>
          <p>{{ fullDetail()!.specialInstructions }}</p>
        </td>
      </tr>
    </tbody>
  </table>
</div>
}

<!-- Status -->
<div class="detail-section">
  <table class="detail-table">
    <tbody>
      <tr>
        <td>
          <strong>Status</strong>
          <p>
            <span class="status-badge">{{ statusLabel() }}</span>
          </p>
        </td>
        <td>
          <strong>Created On</strong>
          <p>{{ o.createdOn ? (o.createdOn | date: 'mediumDate') : '-' }}</p>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!--Line Items -->
<div class="detail-section">
  <h3 class="detail-section__heading">Line Items</h3>
  @if (detailLoading()) {
  <p class="detail-loading">Loading line items...</p>
  } @else if (fullDetail()?.lineItems?.length) {
  <table class="detail-table line-items-table">
    <thead>
      <tr>
        <td>Product</td>
        <td>Quantity</td>
        <td>PO Number</td>
      </tr>
    </thead>
    <tbody>
      @for (item of fullDetail()!.lineItems; track $index) {
      <tr>
        <td>
          <strong class="line-item-name">{{ item.productName }}</strong>
        </td>
        <td>{{ item.quantity }} / EACH</td>
        <td>{{ item.poNumber || '-' }}</td>
      </tr>
      }
    </tbody>
  </table>
  } @else if (fullDetail()) {
  <p class="detail-empty">No line items.</p>
  }
</div>

<!-- Reference / Proof of Delivery -->
<div class="detail-section">
  <h3 class="detail-section__heading">Reference</h3>
  @if (detailLoading()) {
  <p class="detail-loading">Loading...</p>
  } @else if (fullDetail()?.isElectronicPODPresent) {
  <button type="button" class="pod-download-btn" (click)="downloadPod()">
    Download Proof of Delivery
  </button>
  } @else {
  <p class="detail-empty">Proof of Delivery Unavailable</p>
  }
</div>
}